export default __webpack_public_path__ + "static/media/gallery_02.90f868f7.jpg";